"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gavirate": {
    "61d1cbaa": [{
      "hkey": "96c2eb01",
      "slug": "gavirate",
      "name": "Gavirate",
      "primary": true,
      "skipSearch": false
    }],
    "case-dei-monti": [{
      "hkey": "96c2eb01",
      "slug": "gavirate",
      "name": "Gavirate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ad5c3656": [{
      "hkey": "96c2eb01",
      "slug": "gavirate",
      "name": "Gavirate",
      "primary": true,
      "skipSearch": false
    }],
    "cual": [{
      "hkey": "96c2eb01",
      "slug": "gavirate",
      "name": "Gavirate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f7034d3b": [{
      "hkey": "96c2eb01",
      "slug": "gavirate",
      "name": "Gavirate",
      "primary": true,
      "skipSearch": false
    }],
    "fienile-delle-pianezze": [{
      "hkey": "96c2eb01",
      "slug": "gavirate",
      "name": "Gavirate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "069a2900": [{
      "hkey": "96c2eb01",
      "slug": "gavirate",
      "name": "Gavirate",
      "primary": true,
      "skipSearch": false
    }],
    "forte-di-orino": [{
      "hkey": "96c2eb01",
      "slug": "gavirate",
      "name": "Gavirate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b2457981": [{
      "hkey": "96c2eb01",
      "slug": "gavirate",
      "name": "Gavirate",
      "primary": true,
      "skipSearch": false
    }],
    "groppoto": [{
      "hkey": "96c2eb01",
      "slug": "gavirate",
      "name": "Gavirate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cbd4427b": [{
      "hkey": "96c2eb01",
      "slug": "gavirate",
      "name": "Gavirate",
      "primary": true,
      "skipSearch": false
    }],
    "le-vigne": [{
      "hkey": "96c2eb01",
      "slug": "gavirate",
      "name": "Gavirate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ffe10b2e": [{
      "hkey": "96c2eb01",
      "slug": "gavirate",
      "name": "Gavirate",
      "primary": true,
      "skipSearch": false
    }],
    "m-o-benedetto": [{
      "hkey": "96c2eb01",
      "slug": "gavirate",
      "name": "Gavirate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "21cb5126": [{
      "hkey": "96c2eb01",
      "slug": "gavirate",
      "name": "Gavirate",
      "primary": true,
      "skipSearch": false
    }],
    "ronco": [{
      "hkey": "96c2eb01",
      "slug": "gavirate",
      "name": "Gavirate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;